import { Component, Input } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';
import {
  RolloverPropertyTransferredNonShareConsiderationResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred-non-share-consideration.result';
import {
  RolloverNonShareConsiderationResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-non-share-consideration.result';

@Component({
  selector: 'app-rollover-section-85-result',
  templateUrl: './rollover-section-85-result.component.html',
  styleUrls: ['./rollover-section-85-result.component.scss'],
  standalone: false,
})
export class RolloverSection85ResultComponent {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;

  isSectionCollapsed: boolean = false;

  getNumberOfTableLinesForPropertyTransferred(propertyTransferredResult: RolloverPropertyTransferredResult) {
    return Math.max(propertyTransferredResult.nonShareConsiderations.length, (propertyTransferredResult.commonSharesClasses.length + propertyTransferredResult.preferredSharesClasses.length));
  }

  getTitleForNonShareConsideration(nonShareConsiderationResult: RolloverPropertyTransferredNonShareConsiderationResult | RolloverNonShareConsiderationResult): string {
    return this.options.nonShareConsiderations.find(nonShareConsideration => nonShareConsideration.id === nonShareConsiderationResult.id).title;
  }

  shouldShowNonShareConsideration(nonShareConsiderationResult: RolloverPropertyTransferredNonShareConsiderationResult | RolloverNonShareConsiderationResult): boolean {
    return nonShareConsiderationResult.amountOfNonShareConsideration !== 0;
  }
}
